import { ConnectionQuality } from 'livekit-client'
import { cn } from '@/lib/utils'
import { NetworkQualityIndicator } from './network-quality-indicator'
import type { NetworkState } from '@/types/network'

interface ConnectionStatusBadgeProps {
  networkState: NetworkState
  isConnected: boolean
  className?: string
}

export function ConnectionStatusBadge({
  networkState,
  isConnected,
  className,
}: ConnectionStatusBadgeProps) {
  if (!isConnected) {
    return null
  }

  const { localQuality, agentQuality, isAgentConnected, isReconnecting } =
    networkState

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-2.5 py-1 rounded-full',
        'bg-muted/60 text-xs text-muted-foreground',
        className
      )}
    >
      {/* User connection quality */}
      <div className="flex items-center gap-1">
        <span>You</span>
        <NetworkQualityIndicator quality={localQuality} size="sm" />
      </div>

      <span className="text-muted-foreground/40">|</span>

      {/* Agent status */}
      <div className="flex items-center gap-1">
        <span>Tutor</span>
        {isAgentConnected ? (
          <NetworkQualityIndicator
            quality={agentQuality ?? ConnectionQuality.Unknown}
            size="sm"
          />
        ) : (
          <span className="text-yellow-500 text-[10px]">offline</span>
        )}
      </div>

      {/* Reconnecting indicator */}
      {isReconnecting && (
        <>
          <span className="text-muted-foreground/40">|</span>
          <div className="flex items-center gap-1">
            <div className="w-1.5 h-1.5 rounded-full bg-yellow-500 animate-pulse" />
            <span className="text-yellow-600">reconnecting</span>
          </div>
        </>
      )}
    </div>
  )
}
